@import '../../../../../../constants/spacing.module.less';

.summary-api-key {
  display: flex;
  justify-content: space-between;
  gap: @space-16;
  align-items: center;

  h4 {
    min-width: 90px;
    margin-bottom: @space-0;
  }
}

.summary-api-key:not(:last-of-type) {
  margin-bottom: @space-24;
}

.summary-api-key-copy-to-clipboard {
  flex: 1;
}

.summary-warning-banner {
  margin-bottom: @space-24;
  padding: @space-16;
}
